import { gsap } from "gsap";

class Carousel {

  constructor(element) {
    this.element = element
    this.slides = this.element.querySelectorAll('[data-slide]')
    this.nextButton = this.element.querySelector('[data-navigation="next"]')
    this.previousButton = this.element.querySelector('[data-navigation="previous"]')

    this.currentSlide = 0

    this.handleNavigationClick = this.handleNavigationClick.bind(this)
  }

  handleNavigationClick(event) {
    const target = event.target.hasAttribute('data-navigation') && event.target || event.target.closest('[data-navigation]');
    this.update(target.dataset.navigation)
  }

  update(direction) {

    let slideIndex = this.currentSlide

    if (direction === 'next') {

      slideIndex += 1;

      // Wrap to the first slide if this is the last slide
      if (slideIndex >= this.slides.length) {
        slideIndex = 0
      }
    } else if (direction === 'previous') {
      slideIndex -= 1;

      // Wrap to the first slide if this is the last slide
      if (slideIndex < 0) {
        slideIndex = this.slides.length - 1
      }
    }

    const transitionTimeline = gsap.timeline()
    const transitionOutElements = this.getElementsToAnimateForIndex(this.currentSlide)
    const transitionInElements = this.getElementsToAnimateForIndex(slideIndex)

    this.currentSlide = slideIndex

    transitionInElements
      .forEach((elem) => {
        if (elem.hasAttribute('data-slide') || elem.hasAttribute('data-slide-group')) {
          elem.classList.add('ready')
        }
      })

    transitionTimeline.to(
      transitionOutElements,
      {
        autoAlpha: 0,
        x: -25,
        stagger: .1,
        duration: .05,
        onComplete: () => {
          transitionOutElements.forEach((slideOutElement) => {
            slideOutElement.classList.remove('selected')
            slideOutElement.classList.remove('ready')
          })
        }
      },
    )

    transitionTimeline.fromTo(
      transitionInElements,
      {
        autoAlpha: 0,
        x: 25,
      }, {
        autoAlpha: 1,
        x: 0,
        stagger: .1,
        duration: .2,
        onComplete: () => {
          transitionInElements
          .filter((elem) => elem.hasAttribute('data-slide') || elem.hasAttribute('data-slide-group'))
          .forEach((elem) => {
            elem.classList.add('selected')
          })
        }
      },
    )
  }

  getElementsToAnimateForIndex(index) {

    const slide = this.slides[index]

    const slideGroupElements = this.element.querySelectorAll(`[data-slide-group="${index}"]`)
    const slideGroupSubElements = this.element.querySelectorAll(`[data-slide-group="${index}"] [data-animate]`)

    // This becomes a combination of sub elements and containers.
    // When animating the new slide in, the containers should be first.
    // When animating out, the containers should be last
    if (index != this.currentSlide) {
      return [slide, ...slideGroupElements, ...slideGroupSubElements]
    } else {
      return [...slideGroupSubElements, slide, ...slideGroupElements]
    }
  }

  init() {
    this.nextButton.addEventListener('click', this.handleNavigationClick)
    this.previousButton.addEventListener('click', this.handleNavigationClick)
  }
}

export default Carousel
